import { useMemo } from "react";

import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageInfraAssistant } from "hooks/useAnalytics/pages/infraAssistant";

import useAssistantPanelStore from "../Layout/useStore";
import {
  AssistantPanelConversationEntryPoint,
  AssistantPanelLearnModeOpenedProperties,
  AssistantPanelVariantChangedProperties,
} from "./types";

const useAssistantPanelAnalytics = () => {
  const trackEvent = useAnalytics({ page: AnalyticsPageInfraAssistant.InfraAssistant });

  return useMemo(
    () => ({
      trackConversationOpened: (entryPoint: AssistantPanelConversationEntryPoint) =>
        trackEvent("Conversation Opened", {
          entryPoint,
          variant: useAssistantPanelStore.getState().variant,
        }),
      trackConversationDismissed: (engaged: boolean) =>
        trackEvent("Conversation Dismissed", {
          variant: useAssistantPanelStore.getState().variant,
          engaged,
        }),
      trackLearnModeOpened: (properties: AssistantPanelLearnModeOpenedProperties) =>
        trackEvent("Learn Mode Opened", properties),
      trackPanelVariantChanged: (properties: AssistantPanelVariantChangedProperties) =>
        trackEvent("Panel Variant Changed", properties),
    }),
    [trackEvent]
  );
};

export default useAssistantPanelAnalytics;
